// The control-edit page is framed by Control and must not share anything with
// an applicant's session in the same tab. Logging in to Control goes through
// apply-web, so the tab's session storage for this origin can hold the
// applicant's token and refresh token; App would refresh it when it starts and
// replace the case officer's scoped token.
//
// This module is imported first in main.js, before Aurelia starts. On the
// control-edit page it takes the token from the URL fragment and removes the
// fragment, before the router reads the address and writes it back.
// SessionStorage then starts in memory (see services/storage.js).

const CONTROL_EDIT_PATH = /^\/[^/]+\/applications\/[^/]+\/control-edit\/?$/;

export function readControlEditPage(location, history) {
  if (!CONTROL_EDIT_PATH.test(location.pathname)) return { isControlEditPage: false, token: null };

  const token = new URLSearchParams((location.hash || "").replace(/^#/, "")).get("token");
  if (location.hash) {
    history.replaceState(null, "", location.pathname + location.search);
  }
  return { isControlEditPage: true, token };
}

const page = readControlEditPage(window.location, window.history);

export const isControlEditPage = page.isControlEditPage;

let token = page.token;

// takeControlEditToken returns the token once; later calls get null.
export function takeControlEditToken() {
  const t = token;
  token = null;
  return t;
}
